// extracted by mini-css-extract-plugin
module.exports = {"ContactMenu":"ContactMenu_ContactMenu__ODsbt","ContactMenuColumn":"ContactMenu_ContactMenuColumn__3ZRNG"};